import React, { useCallback } from "react";
import { useHistory, useParams } from "react-router";
import { createServiceFormValidator } from "../../validators";
import { Form } from "react-final-form";
import Paper from "@material-ui/core/Paper";
import { Theme } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Loading from "../../../../components/Loading";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import makeStyles from "@material-ui/core/styles/makeStyles";
import ServiceForm from "../../components/admin/ServiceForm";
import { AdapterLink } from "../../../../components/Adopter";
import { useSnackbar } from "notistack";
import { queryCache, useQuery } from "react-query";
import { Routes } from "../../../../constants/routes";
import { mutateErrors } from "../../../../utils";
import { FORM_ERROR } from "final-form";
import Error from "../../../../components/Error";
import useServiceQueries from "../../hooks/useServiceQueries";
import { QUERY_KEYS } from "../../../../constants";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: 35,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      padding: 15,
    },
  },
  formControl: {
    marginBottom: theme.spacing(3),
  },
  root: {
    margin: "0 auto",
  },
}));

export default function EditPage() {
  const classes = useStyles();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const params = useParams<{ id: string }>();
  const { fetchOne, fetchUpdate } = useServiceQueries();

  const { services } = QUERY_KEYS;

  const { isLoading, isFetching, isError, error, data } = useQuery<any>(
    "service_" + params.id,
    () => {
      return fetchOne(params.id);
    },
  );

  const update = useCallback(
    async (data) => {
      try {
        await fetchUpdate(data);
        await queryCache.invalidateQueries(services);
        history.push(`/0/${Routes.SERVICES_ADMIN}`);
        enqueueSnackbar("Success", { variant: "success" });
      } catch (e) {
        const { errors, message } = mutateErrors(e);
        enqueueSnackbar(message, { variant: "error" });
        return { [FORM_ERROR]: message, ...errors };
      }
    },
    [fetchUpdate],
  ); // eslint-disable-line react-hooks/exhaustive-deps

  if (isLoading || isFetching) return <Loading />;

  if (isError) {
    const { message } = mutateErrors(error);
    return <Error text={message} />;
  }

  return (
    <Container maxWidth="md" className={classes.container}>
      <Breadcrumbs>
        <AdapterLink to="/0">Home</AdapterLink>
        <AdapterLink to="/0/service">Services</AdapterLink>
        <Typography color="textPrimary">Edit Service</Typography>
      </Breadcrumbs>
      <Paper>
        <Form
          onSubmit={update}
          validate={createServiceFormValidator}
          initialValues={{
            id: data && data.data.id,
            title: data && data.data.title,
            link: data && data.data.link,
            description: data && data.data.description,
            category: data && data.data.category,
            image: data && data.data.image,
            isWithPage: data && data.data.isWithPage,
          }}
          component={ServiceForm}
        />
      </Paper>
    </Container>
  );
}
